import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

interface UseDisableProductNfceMappingProps {
  productNfceMappingId: string
  onSuccess?: () => void
  onError?: (error: AxiosError) => void
}

export const useDisableProductNfceMapping = ({
  productNfceMappingId,
  onSuccess,
  onError,
}: UseDisableProductNfceMappingProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation<void, AxiosError, void>({
    mutationKey: ['disableProductNfceMapping', productNfceMappingId],
    mutationFn: () => privateAxios.put(`/product_nfce_mappings/${productNfceMappingId}/disable`),
    onSuccess,
    onError,
  })
}
